// utils/getMember.js
import { authOptions } from '@/app/api/auth/[...nextauth]/route'
import { getServerSession } from 'next-auth'
import { redirect } from 'next/navigation'

export async function getMemberCard(currentPath) {
  const session = await getServerSession(authOptions)
  return session?.CardClass ?? null
}
